module.exports = __webpack_public_path__ + "static/img/teaser3.a4332cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teaser3.png
// module id = EcyN
// module chunks = 0